import i18next, { type Resource } from "i18next";
import { initReactI18next } from "react-i18next";

import en from "@/assets/locales/en.json";
import { getQueryParam } from "@/utils";
import { debugError } from "@/utils";

const resources = {
    en: { translation: en },
} satisfies Resource;

const FALLBACK_LANGUAGE = "en" as const;

type SupportedLanguage = keyof typeof resources;

const pickSupportedLanguage = (candidate: string | null): SupportedLanguage | null => {
    if (!candidate) {
        return null;
    }

    const normalized = candidate.toLowerCase();
    if (normalized in resources) {
        return normalized as SupportedLanguage;
    }

    const shortCode = normalized.split("-")[0];
    if (shortCode in resources) {
        return shortCode as SupportedLanguage;
    }

    return null;
};

const detectLanguage = (): SupportedLanguage => {
    const langFromUrl = getQueryParam("lang");
    const matched = pickSupportedLanguage(langFromUrl);
    if (matched) {
        return matched;
    }

    return FALLBACK_LANGUAGE;
};

void i18next
    .use(initReactI18next)
    .init({
        resources,
        lng: detectLanguage(),
        fallbackLng: FALLBACK_LANGUAGE,
        interpolation: {
            escapeValue: false,
        },
    })
    .catch((error: unknown) => {
        debugError("[i18n] init failed", error);
    });

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = Object.keys(resources) as SupportedLanguage[];
export const DEFAULT_LANGUAGE = FALLBACK_LANGUAGE;

export default i18next;
